import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { CircularProgress } from "@mui/material";
import { ComponentType, Suspense, lazy } from "react";

export {
    LazyResizeableCodeEditor,
    LazyVisualCodeEditor,
} from "components/Form/lazyCodeEditorComponents";

const formFieldFallback = (
    <div style={{ minHeight: 120, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={24} />
    </div>
);

const lazyFormField = (
    loader: () => Promise<{ default: ComponentType<FormComponentProps> }>,
    fallback = formFieldFallback
) => {
    const LazyComponent = lazy(loader);

    return (props: FormComponentProps) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    );
};

export const LazySchemaFormFormComponent = lazyFormField(() =>
    import("components/Form/components/SchemaForm/SchemaFormFormComponent").then((module) => ({
        default: module.SchemaFormFormComponent,
    }))
);

export const LazySchemaFormConditionalFormComponent = lazyFormField(() =>
    import("components/Form/components/SchemaForm/SchemaFormConditionalFormComponent").then(
        (module) => ({
            default: module.SchemaFormConditionalFormComponent,
        })
    )
);
